<template>
  <div class="detail-content">
    <div class="detail-content-title">
      <h1>【双喜临门】我们搬家了</h1>
      <h4>2018-11-22<span>朗拓健康</span></h4>
    </div>
    <div class="detail-content-main">
      <p>
        今天是感恩节，值此佳节，恭祝江苏朗拓健康科技有限公司乔迁之喜！让我们在新的城池继续开疆扩土！
      </p>
      <p>
        公司经过快速且稳健的发展，运营规模不断扩大，员工逐渐增加，原办公地点已不能满足发展需求，本次搬迁对朗拓而言，是一个新的里程碑，更是个全新的开始！ ‍‍‍‍‍‍
      </p>
      <span>在这里，没有我，只有我们</span>
      <span>除了汗水，还有欢笑</span>
      <span>除了奔跑，还有牵挂</span>
      <span>有付出，有收获，还有满满的祝福</span>
      <span>只因我们都在这里</span>
      <img src="../../assets/images/trend4/1.png"/>
    </div>
  </div>
</template>

<script  type="text/javascript">
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/trend/Trend4.vue